import { Link } from 'react-router-dom'

// Shown in place of the app shell for any account with no personalized AI
// plan yet (see Health.jsx's AppShell) - onboarding tries to generate one
// automatically, but a skipped profile field or a failed generation call
// leaves the account with nothing to show, and there is no shared default
// plan to fall back to (the bundled plan data is Shashank's own, served
// only to his account via his personal AI plan doc).
export default function PlanNotReady() {
  return (
    <div className="login-page">
      <div className="login-brand-panel">
        <img src="/health-icons/icon-512.png" alt="" className="login-brand-mark" />
        <h2 className="login-brand-title">HealthNest</h2>
        <p className="login-brand-tagline">Your 90-day plan, tracked in full - workouts, meals, macros, and progress, all in one place.</p>
        <ul className="login-brand-features">
          <li>Full macro + micronutrient tracking</li>
          <li>Workout logging with personal records</li>
          <li>Pantry &amp; shopping list management</li>
          <li>Progress photos and weekly reviews</li>
        </ul>
      </div>
      <div className="login-form-side">
        <div className="login-card">
          <h1>Your plan isn't ready yet</h1>
          <p className="muted">
            We couldn't find a personalized 90-day plan for your account. This usually means plan generation didn't run
            yet, or it failed - head to Settings to generate one from your profile.
          </p>
          <Link to="/settings" className="btn btn-primary full-width" style={{ marginTop: 18, display: 'block', textAlign: 'center' }}>
            Go to Settings
          </Link>
        </div>
      </div>
    </div>
  )
}
